import styled from '@emotion/styled'

const StyledIcon = styled.div`
  float: left;
  padding: 0.2rem 0.2rem 0 0.2rem;
  line-height: 20px;
  /* border:1px solid pink; */
  box-sizing: border-box;
`

export default StyledIcon
